import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const getDetailCompanySo = createAsyncThunk('/dashboard_detail_company_so/content', async (id) => {
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/dashDetailCompanySo/${id}`, {})
    return response.data;
})

export const dashboardDetailCompanySoSlice = createSlice({
    name: 'dashboard_detail_company_so',
    initialState: {
        isLoading: false,
        dashboard_detail_company_so: []
    },

    /*extraReducers: {
        [getDetailCompanySo.pending]: state => {
            state.isLoading = true
        },
        [getDetailCompanySo.fulfilled]: (state, action) => {
            state.dashboard_detail_company_so = action.payload.data
            state.isLoading = false
        },
        [getDetailCompanySo.rejected]: state => {
            state.isLoading = false
        },
    }*/
    extraReducers: (builder) => {
        builder
            .addCase(getDetailCompanySo.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getDetailCompanySo.fulfilled, (state, action) => {
                state.dashboard_detail_company_so = action.payload.data;
                state.isLoading = false;
            })
            .addCase(getDetailCompanySo.rejected, (state) => {
                state.isLoading = false;
            });
    }   
})

export default dashboardDetailCompanySoSlice.reducer